/* eslint-disable react/no-array-index-key */

import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import NavCard from './NavCard.jsx'
import CategoryNavigation from './CategoryNavigation.jsx'
import { viewports, breakpoints } from '../../../helpers/ComponentHelper'
import * as Styled from './M012.styles'

/**
 * - M012 is a taxonomy grouping with offers component used by the nav team on smaller screen sizes, from tablet to small mobile.
 */
const M012 = (props) => {
  const [viewport, setViewport] = useState('')
  const mql = useRef({})

  const handleResize = () => {
    if (mql.current.matches) {
      setViewport(viewports.SMALL)
    } else {
      setViewport(viewports.MOBILE)
    }
  }

  useEffect(() => {
    mql.current = window.matchMedia(breakpoints.SMALL)
  }, [viewport])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getCategoryGroup = (categoryGroup) => {
    return categoryGroup.attributes.children.map((item, index) => (
      <NavCard
        dataTest='m012'
        index={index}
        key={item.attributes.name + index}
        name={item.attributes.name}
        image={item?.attributes?.image}
        type={item.type}
        altText={item.attributes.name}
        linkUrl={item.attributes.path}
        onLinkClick={props.onLinkClick}
      />
    ))
  }

  return (
    <Styled.PaddedRow
      data-test='m012-content-container'
      row='xs'
      hidden={!props.navigation.alwaysShowNavigation ? 'lg' : undefined}
      negative='xs'
      gutterSize='15px'
    >
      {props.navigation.children.map((categoryGroup, index) => {
        if (categoryGroup.type === 'Sub-Heading') {
          return (
            <CategoryNavigation
              dataTest='m012'
              index={index}
              itemKey={categoryGroup.attributes.name}
              name={categoryGroup.attributes.name}
              key={index}
            >
              {getCategoryGroup(categoryGroup)}
            </CategoryNavigation>
          )
        }
        return (
          <NavCard
            dataTest='m012'
            index={index}
            key={categoryGroup.attributes.name + index}
            name={categoryGroup.attributes.name}
            image={categoryGroup.attributes.image}
            type={categoryGroup.type}
            altText={categoryGroup.attributes.name}
            linkUrl={categoryGroup.attributes.path}
            onLinkClick={props.onLinkClick}
          />
        )
      })}
    </Styled.PaddedRow>
  )
}
M012.propTypes = {
  /** Optional object with children of the categories */
  navigation: PropTypes.object,
  /** Optional function to handle the click on the container  */
  onLinkClick: PropTypes.func
}

M012.defaultProps = {
  navigation: {},
  onLinkClick: null
}

export default M012
